module.exports = __webpack_public_path__ + "img/yzy.e395c1b4.png";